import { atom } from "recoil";

export const locationUrlAtom = atom({
  key: "locationUrl",
  default: [],
});
